import { request } from './request';

export const getMe = () => request('users/me');

export const updateProfile = (body) =>
  request(
    'users/update',
    { method: 'PATCH', body },
    'Profile updated successfully!',
  );

export const getAllUsersWithNursesAndAdmins = async () => {
  return request('users/tasks', { method: 'GET' });
};
